import { Container, Row } from 'reactstrap'
import AccountTabs from './AccountSettingsTabs/AccountTabs'
import Breadcrumbs from '../../CommonElements/Breadcrumbs/Breadcrumbs'
import { AccountSettings, BankSettings, profile, Settings } from '../../utils/Constant'


const MyProfileContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BankSettings} parent={Settings} ChildName={BankSettings} />
      <Container fluid className='edit-profile'>
        <Row>
          <AccountTabs/>
        </Row>
      </Container>
    </>
  )
}

export default MyProfileContainer